import { BaseApiService } from '@services/baseApiService';
import { UserOutputDTO } from '@types';
import { ApiResponse, ApiError } from '@/types/api';

class UserService extends BaseApiService<UserOutputDTO> {
  constructor() {
    super('users');
  }

  async create(data: Partial<UserOutputDTO>): Promise<ApiResponse<UserOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const userData = {
      ...data,
    };
    
    return await super.create(userData);
  }

  async update(id: string, data: Partial<UserOutputDTO>): Promise<ApiResponse<UserOutputDTO> | ApiError> {
    // Remove sensitive data if needed
    const userData = {
      ...data,
    };
    
    return await super.update(id, userData);
  }

  // You can add user-specific methods here if needed
}

export const userService = new UserService(); 